import PlayerActions from '../enums/PlayerActions';
import { IframeMessengerable } from '../IframeMessengerPlayerAbstract';
import { RestartApplicationInterface } from '../interfaces/RestartApplicationInterface';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function ApplicationRestartable<TBase extends IframeMessengerable>(Base: TBase) {
    return class ApplicationRestartable extends Base implements RestartApplicationInterface {
        restartApplication(): Promise<void> {
            this._performPlayerAction(PlayerActions.APPLICATION_RESTART);
            return Promise.resolve();
        }
    };
}
